module.exports = __webpack_public_path__ + "static/media/hn.ed51c1b1.svg";